
export const BASE_URL_API = 'https://api.piscan.io';
export const BASE_URL_API_V2 = 'https://apiv2.piscan.io';

export const PiscanAPI={
    TopAccount:BASE_URL_API+'/top-accounts',
    AccountsDistribution:BASE_URL_API+'/accounts/distribution',
    CheckScamWallet:BASE_URL_API+'/check-scam-wallet',
    MainnetSupply:BASE_URL_API+'/data/mainnet-supply',
    UnlockNext30Days:BASE_URL_API+'/data/unlocknext30d',
    UnlockStatisticsFull:BASE_URL_API+'/data/unlockfull',
    Contact :BASE_URL_API+'/contact',
    ReportScam:BASE_URL_API+'/report-scam',
    NodeMap:BASE_URL_API_V2+'/data/nodemap_v2',
    Transactions:BASE_URL_API+'/transactions',
}